import {
  GET_ACTIVITIES_BEGIN,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_ERROR,
  DISPLAY_ALERT,
  CLEAR_ALERT,
  SETUP_USER_BEGIN,
  SETUP_USER_SUCCESS,
  SETUP_USER_ERROR,
  TOGGLE_SIDEBAR,
  LOGOUT_USER,
  UPDATE_USER_BEGIN,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  HANDLE_CHANGE,
  CLEAR_VALUES,
  CREATE_LESSON_BEGIN,
  CREATE_LESSON_SUCCESS,
  CREATE_LESSON_ERROR,
  GET_LESSONS_BEGIN,
  GET_LESSONS_SUCCESS,
  SET_EDIT_LESSON,
  DELETE_LESSON_BEGIN,
  DELETE_LESSON_ERROR,
  EDIT_LESSON_BEGIN,
  EDIT_LESSON_SUCCESS,
  EDIT_LESSON_ERROR,
  CLEAR_FILTERS,
  CHANGE_PAGE,
  GET_CURRENT_USER_BEGIN,
  GET_CURRENT_USER_SUCCESS,
} from '../utils/actions';
import { initialState } from '../context/GlobalContext';

const GlobalReducer = (state, action) => {
  if (action.type === GET_ACTIVITIES_BEGIN) {
    return { ...state, activities_loading: true, showAlert: false };
  }
  if (action.type === GET_ACTIVITIES_SUCCESS) {
    return {
      ...state,
      activities_loading: false,
      activities: action.payload.activities,
      totalActivities: action.payload.totalActivities,
      numOfPages: action.payload.numOfPages,
    };
  }
  if (action.type === GET_ACTIVITIES_ERROR) {
    return { ...state, activities_error: true, showAlert: false };
  }
  if (action.type === DISPLAY_ALERT) {
    return {
      ...state,
      showAlert: true,
      alertType: 'danger',
      alertText: 'Please provide all values!',
    };
  }
  if (action.type === CLEAR_ALERT) {
    return {
      ...state,
      showAlert: false,
      alertType: '',
      alertText: '',
    };
  }

  if (action.type === SETUP_USER_BEGIN) {
    return { ...state, userLoading: true };
  }
  if (action.type === SETUP_USER_SUCCESS) {
    return {
      ...state,
      userLoading: false,
      isLoggedIn: true,
      user: action.payload.user[0],
      showAlert: true,
      alertType: 'success',
      alertText: action.payload.alertText,
    };
  }
  if (action.type === SETUP_USER_ERROR) {
    return {
      ...state,
      userLoading: false,
      isLoggedIn: false,
      showAlert: true,
      alertType: 'danger',
      alertText: action.payload.msg,
    };
  }
  if (action.type === TOGGLE_SIDEBAR) {
    return {
      ...state,
      showSidebar: !state.showSidebar,
    };
  }
  if (action.type === LOGOUT_USER) {
    return {
      ...initialState,
      user: null,
      userLoading: false,
      isLoggedIn: false,
    };
  }
  if (action.type === UPDATE_USER_BEGIN) {
    return { ...state, isLoading: true };
  }
  if (action.type === UPDATE_USER_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      user: action.payload.user,
      showAlert: true,
      alertType: 'success',
      alertText: 'User Profile Updated!',
    };
  }
  if (action.type === UPDATE_USER_ERROR) {
    return {
      ...state,
      isLoading: false,
      showAlert: true,
      alertType: 'danger',
      alertText: action.payload.msg,
    };
  }
  if (action.type === HANDLE_CHANGE) {
    return {
      ...state,
      page: 1,
      [action.payload.name]: action.payload.value,
    };
  }
  if (action.type === CLEAR_VALUES) {
    const initialState = {
      isEditing: false,
      editLessonId: '',
      day: '',
      date: '',
      duration: '',
      age: '',
      lessonLocationName: '',
      lessonLocationAddress: '',
      lessonType: 'Family Acro Yoga',
      status: 'pending',
    };

    return {
      ...state,
      ...initialState,
    };
  }
  if (action.type === CREATE_LESSON_BEGIN) {
    return { ...state, isLoading: true };
  }

  if (action.type === CREATE_LESSON_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      showAlert: true,
      alertType: 'success',
      alertText: 'New Lesson Created!',
    };
  }
  if (action.type === CREATE_LESSON_ERROR) {
    return {
      ...state,
      isLoading: false,
      showAlert: true,
      alertType: 'danger',
      alertText: action.payload.msg,
    };
  }
  if (action.type === GET_LESSONS_BEGIN) {
    console.log('get lessons begin');
    return { ...state, isLoading: true, showAlert: false };
  }
  if (action.type === GET_LESSONS_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      lessons: action.payload.lessons,
      totalLessons: action.payload.totalLessons,
      numOfPages: action.payload.numOfPages,
    };
  }
  if (action.type === SET_EDIT_LESSON) {
    const lesson = state.lessons.find(
      (lesson) => lesson._id === action.payload.id
    );
    const {
      _id,
      day,
      date,
      duration,
      age,
      lessonLocationName,
      lessonLocationAddress,
      lessonType,
      status,
    } = lesson;

    return {
      ...state,
      isEditing: true,
      editJobId: _id,
      day,
      date,
      duration,
      age,
      lessonLocationName,
      lessonLocationAddress,
      lessonType,
      status,
    };
  }
  if (action.type === DELETE_LESSON_BEGIN) {
    return { ...state, isLoading: true };
  }
  if (action.type === DELETE_LESSON_ERROR) {
    return {
      ...state,
      isLoading: false,
      showAlert: true,
      alertType: 'danger',
      alertText: action.payload.msg,
    };
  }
  if (action.type === EDIT_LESSON_BEGIN) {
    return {
      ...state,
      isLoading: true,
    };
  }
  if (action.type === EDIT_LESSON_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      showAlert: true,
      alertType: 'success',
      alertText: 'Job Updated!',
    };
  }
  if (action.type === EDIT_LESSON_ERROR) {
    return {
      ...state,
      isLoading: false,
      showAlert: true,
      alertType: 'danger',
      alertText: action.payload.msg,
    };
  }
  if (action.type === CLEAR_FILTERS) {
    return {
      ...state,
      search: '',
      searchStatus: 'all',
      searchType: 'all',
      sort: 'latest',
    };
  }
  if (action.type === CHANGE_PAGE) {
    return { ...state, page: action.payload.page };
  }
  if (action.type === GET_CURRENT_USER_BEGIN) {
    return { ...state, userLoading: true, showAlert: false };
  }
  if (action.type === GET_CURRENT_USER_SUCCESS) {
    return {
      ...state,
      userLoading: false,
      user: action.payload.user,
    };
  }
  throw new Error(`no such action : ${action.type}`);
};

export default GlobalReducer;
